import React from 'react'
import Riepilogo from './riepilogo'
import RiepilogoCard from './riepilogoCard'
import RiepilogoCardFotoDescrizione from './riepilogoCardFotoDescrizione'
import RiepilogoCardDettagli from './riepilogoCardDettagli'
import { Row } from 'antd'
import { RiepilogoButton } from './buttons'

const RiepilogoFotoDescrizione = (props) => {
  return (
    <Riepilogo
      title='Hai completato la seconda parte!'
      subtitle='Controlla le informazioni inserite e passa al gruppo successivo'
    >
      <RiepilogoButton text='continua' onClick={props.incrementStep} />
      <Row gutter={[16, 16]}>
        <RiepilogoCard cardTitle='Foto & Descrizione'>
          <RiepilogoCardFotoDescrizione {...props} />
        </RiepilogoCard>
        <RiepilogoCard cardTitle='Dettagli annuncio'>
          <RiepilogoCardDettagli {...props} />
        </RiepilogoCard>
      </Row>
    </Riepilogo>
  )
}

export default RiepilogoFotoDescrizione
